export const USER_ID_ERROR_MESSAGE = 'Failed to get user id';

export enum PreferencesKey {
  firstLogin = 'firstLogin',
}
